import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const PaymentInstructionsModal = ({ show, onHide, onConfirm, totalAmount }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Manual Payment Instructions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h6>Instructions:</h6>
        <p className="mb-1 small">
          Please send <strong>${totalAmount.toFixed(2)}</strong> to:
        </p>
        <ul className="list-unstyled mb-3 small">
          <li><strong>Recipient:</strong> Masimba Maregedze</li>
          <li><strong>Phone (EcoCash, InnBucks, etc.):</strong> 0778740934</li>
          <li><strong>Bank Details:</strong> Available on request (email finance@marmasco.com)</li>
          <li><strong>Reference:</strong> Your Order Reference(s) or Account Email</li>
        </ul>
        <hr />
        <p className="small text-muted">
          Once payment is complete, you will need to upload your Proof of Payment (POP) to confirm the order. Click "Okay, Upload POP" to proceed with the upload.
        </p>
      </Modal.Body>
      <Modal.Footer className="justify-content-between"> {/* Use justify-content-between */}
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          Okay, Upload POP
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PaymentInstructionsModal;
